import { render, staticRenderFns } from "./FilesUploadForm.vue?vue&type=template&id=a0f5cdc8&scoped=true&"
import script from "./FilesUploadForm.vue?vue&type=script&lang=js&"
export * from "./FilesUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./FilesUploadForm.vue?vue&type=style&index=0&id=a0f5cdc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f5cdc8",
  null
  
)

export default component.exports